import { Redirect, useParams } from "react-router-dom";
import { PageHeaderWithBack } from "../../../Components/Molecules";
import { useAuth } from "../../../Contexts/AuthContext";
import { ContaInternacionalMovimentarContent } from "./components/ContaInternacionalMovimentarContent";
import {
  CONTA_INTERNACIONAL_HOME_PATH,
  contaInternacionalCurrencyPath,
  getCurrency,
} from "./constants";

export const ContaInternacionalMovimentar = () => {
  const { hasPermission } = useAuth();
  const { currencyId } = useParams();
  const currency = getCurrency(currencyId);

  if (!hasPermission("internationaltransfer")) {
    return <Redirect to={CONTA_INTERNACIONAL_HOME_PATH} />;
  }

  if (!currency) {
    return <Redirect to={CONTA_INTERNACIONAL_HOME_PATH} />;
  }

  return (
    <div className="w-full">
      <PageHeaderWithBack
        title="Movimentar entre contas"
        subTitle="Transfira saldo entre suas contas em moedas diferentes."
        backTo={contaInternacionalCurrencyPath(currency.id)}
      />

      <div className="app-card p-4 sm:p-5">
        <ContaInternacionalMovimentarContent isActive currencyId={currency.id} />
      </div>
    </div>
  );
};
